import { Card } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { useInvoiceDetailStore } from "../../store";
import { CardTitle } from "../common";

export const InternalNoteCard = () => {
  const store = useInvoiceDetailStore();

  return (
    <Card>
      <Card.Section>
        <CardTitle>{t`Internal note`}</CardTitle>
        <p>{store.invoice?.internal_note}</p>
      </Card.Section>
    </Card>
  );
};
